export function checkIsUserDemo(user) {
    if (user.cnpj === '00000000000000' && user.idUsuario === '0' && user.senha === '0') {
        return true
    }
    else {
        return false
    }
}
